export const ANSWER = "ANSWER";
export const HISTORY = "HISTORY";
export const CHOICE = "CHOICE";
export const LAUNCH_ACTIVITY = "LAUNCH_ACTIVITY";
export const TERMINATE_ACTIVITY = "TERMINATE_ACTIVITY";
export const MAINTAIN_ACTIVITY = "MAINTAIN_ACTIVITY";
export const INIT_ACTIVITY = "INIT_ACTIVITY";
export const DISCONNECT = "DISCONNECT";
export const IDLE = "IDLE";
